const shadows = {
  outline: {
    boxShadow: 'none',
  },
};

export default shadows;
